export default function editHousingCorporationName(
  {patch}: any,
  {cid, name}: {cid: number; name: string},
): Promise<{}> {
  return patch(
    `/housing-corporations/name?corporationId=${cid}`,
    {name},
    {retryOn401: true},
  )
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/editHousingCorporationName.tsx